<template>
  <div>
    <b-row>
      <b-col>
        <p>Calculate Rating by date range </p>
        <label for="example1-datepicker">Start Date</label>
        <b-form-datepicker id="example1-datepicker" v-model="startDate" class="mb-2" reset-button></b-form-datepicker>
        <label for="example2-datepicker">End Date</label>
        <b-form-datepicker id="example2-datepicker" v-model="endDate" class="mb-2" reset-button></b-form-datepicker>
      </b-col>
    </b-row>
    <b-spinner variant="primary" label="Spinning" v-if="loadingRating"></b-spinner>
    <b-row v-if="!loadingRating" class="my-4">
      <b-col>
        <p>Total: {{rating.totalRatings}}</p>
      </b-col>
      <b-col class="text-center">
        <h2>Average Rating: {{rating.averageRating | round(0)}}</h2>
        <b-form-rating id="rating-lg" v-model="rating.averageRating" size="lg" variant="primary" :readonly="true"></b-form-rating>
      </b-col>
      <b-col></b-col>
    </b-row>
    <b-row v-if="!loadingRating">
      <table class="table">
        <thead class="text-center">
          <tr>
            <th>
              1
            </th>
            <th>
              2
            </th>
            <th>
              3
            </th>
            <th>
              4
            </th>
            <th>
              5
            </th>
            <th>
              Average
            </th>
          </tr>
        </thead>
        <tbody class="text-center">
          <tr>
            <td>
              <p>{{rating.ratings[0].average * 100 | round(2)}}%</p>
              <p>{{rating.ratings[0].count}}</p>
            </td>
            <td>
              <p>{{rating.ratings[1].average * 100 | round(2)}}%</p>
              <p>{{rating.ratings[1].count}}</p>
            </td>
            <td>
              <p>{{rating.ratings[2].average * 100 | round(2)}}%</p>
              <p>{{rating.ratings[2].count}}</p>
            </td>
            <td>
              <p>{{rating.ratings[3].average * 100 | round(2)}}%</p>
              <p>{{rating.ratings[3].count}}</p>
            </td>
            <td>
              <p>{{rating.ratings[4].average * 100 | round(2)}}%</p>
              <p>{{rating.ratings[4].count}}</p>
            </td>
            <td>
              <p>{{rating.averageRating | round(2)}}</p>
            </td>
          </tr>
        </tbody>
      </table>
    </b-row>
    <b-row>
      <b-col><h2>Submitted Surveys</h2></b-col>
      <b-spinner variant="primary" label="Spinning" v-if="loading"></b-spinner>
    </b-row>
    <b-row>
      <b-col>
        <b-table :items="surveys" :fields="fields" :busy="loading">
          <template v-slot:cell(submittedOn)="data">
            <p>{{ data.value | formatDate('MM-DD-YYYY') }}</p>
          </template>
          <template v-slot:cell(course)="data">
            <b-button class="text-left" variant="link" :to="{ name: 'Course', params: { id: data.item.courseId} }">{{data.item.course.title}}</b-button>
          </template>
          <template v-slot:cell(student)="data">
            <router-link class="text-left" variant="link" :to="{ name: 'User', params: { id: data.item.user.id} }">{{data.item.user.name}}</router-link>
          </template>
          <template v-slot:cell(comments)="data">
            <p style="overflow: hidden; max-width: 500px;">{{data.value}}</p>
          </template>
          <template v-slot:cell(actions)="data">
            <b-button @click="deleteSurvey(data.item)" variant="link" style="display: inline;">Delete</b-button>
          </template>
        </b-table>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import Api from '@/api/Api'

Vue.filter('round', (value, places) => {
  if (!value) {
    return ''
  }
  return value.toFixed(places)
})

Vue.filter('formatDate', function (value, format) {
  if (moment(value).isValid() && moment(value).year() > 1) {
    if (format) {
      return moment(value).format(format)
    } else {
      return moment(value).format('MMMM Do YYYY hh:mm a')
    }
  } else {
    return ''
  }
})

export default {
  props: {
    courseId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      loading: true,
      loadingRating: true,
      surveys: [],
      startDate: null,
      endDate: null,
      fields: [
        { key: 'course', label: 'Course' },
        { key: 'student', label: 'Student' },
        { key: 'submittedOn', label: 'Submitted' },
        { key: 'instructorRating', label: 'Instructor Rating' },
        { key: 'trainingTeamRating', label: 'Training Team Rating' },
        { key: 'trainingScheduleRating', label: 'Training Schedule Rating' },
        { key: 'overallRating', label: 'Overall Rating' },
        { key: 'wouldRecommend', label: 'Would Recommend' },
        { key: 'comments', label: 'Comments' },
        { key: 'actions', label: '' } ]
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.courseId}/Surveys`)
        .then((r) => {
          vm.surveys = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
        })

      vm.loadingRating = true

      let dateFilter = ''
      if (vm.startDate) {
        dateFilter += `startDate=${vm.startDate}`
        if (vm.endDate) {
          dateFilter += '&'
        }
      }
      if (vm.endDate) {
        dateFilter += `endDate=${vm.endDate}`
      }
      let url2 = `Course/${vm.courseId}/Rating`
      if (dateFilter) {
        url2 += '?' + dateFilter
      }
      Api().get(url2)
        .then((r) => {
          vm.rating = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loadingRating = false
        })
    },
    deleteSurvey (survey) {
      this.$bvModal.msgBoxConfirm('Are you sure you want to delete this survey?', {
        title: 'Delete User?',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'YES',
        cancelTitle: 'NO',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      })
        .then(value => {
          if (value) {
            var vm = this
            vm.loading = true
            Api().delete(`Course/${survey.courseId}/Surveys/${survey.userId}`)
              .then((r) => {
                vm.surveys.splice(vm.surveys.findIndex((i) => { return i.userId === survey.userId && i.courseId === survey.courseId }), 1)
              })
              .catch((e) => {
                console.log(e)
              })
              .finally(() => {
                vm.loading = false
              })
          }
        })
    }
  },
  watch: {
    startDate (value) {
      this.loadData()
    },
    endDate (value) {
      this.loadData()
    }
  }
}
</script>

<style scoped>

</style>
